import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { TemplateContext } from 'providers/template-provider';
import { getValuesById } from 'utils';
import { ContentWrapper, SelectMenu, Textarea, Textbox } from 'components/generic';

const GeneralDetails = () => {
	const context = useContext(TemplateContext);
	const referenceData = useSelector(state => state?.referenceData)?.data;
	const { dockerState, createObj, setCreateObj } = context;

	const templateType = getValuesById(referenceData, 'rd_templateType')?.at()?.value || [];
	const onChangeData = (e, key) => {
		setCreateObj(prevState => ({ ...prevState, [key]: e }));
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='row'>
					<div className='col-6'>
						<Textbox label='Template Name' placeholder='Enter template name' value={createObj?.templateName} mandatory onChange={e => onChangeData(e?.target?.value, 'templateName')} disabled={['edit', 'view']?.includes(dockerState)} />
					</div>
				</div>
				<div className='row'>
					<div className='col-6'>
						<Textarea
							label='Template Description'
							placeholder='Additional information about template'
							value={createObj?.templateDescription}
							mandatory
							onChange={e => onChangeData(e?.target?.value, 'templateDescription')}
							disabled={dockerState === 'view'}
						/>
					</div>
				</div>
				<div className='row'>
					<div className='col-6'>
						<SelectMenu label='Template Type' mandatory placeholder='Select' menuOptions={templateType} value={getValuesById(templateType, createObj?.templateType)} onChange={e => onChangeData(e, 'templateType')} />
					</div>
				</div>
			</ContentWrapper>
		</>
	);
};

export default GeneralDetails;
